var _classCallCheck = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/mikhail/Documents/kolmonet/app/node_modules/@babel/runtime/helpers/createClass");

(function () {
  if (typeof global !== "undefined") {// global already exists
  } else if (typeof window !== "undefined") {
    window.global = window;
  } else if (typeof self !== "undefined") {
    self.global = self;
  } else {
    throw new Error("cannot export (neither global, window nor self is defined)");
  }

  var MANIFEST_PREFIX = "/manifest/";
  var RAWDATA_PREFIX = "/rawdata/";

  global.Cache =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class(settings) {
      _classCallCheck(this, _class);

      this.Use_localStorage = true;
      this.innerStorage = new Map();

      if (settings) {
        if (settings.hasOwnProperty("Use_localStorage")) this.Use_localStorage = settings["Use_localStorage"];
      }
    }

    _createClass(_class, [{
      key: "get_manifest_by_doi",
      value: function get_manifest_by_doi(doi) {
        var result = {
          status: "Not found",
          data: null
        };
        var key = MANIFEST_PREFIX + doi;

        if (this.Use_localStorage) {
          try {
            var _manifest = localStorage.getItem(key);

            if (_manifest) {
              result.status = "ok";
              result.data = new global.Manifest(JSON.parse(_manifest));
              return result;
            }
          } catch (error) {
            console.log("get_manifest_by_doi, localStorage.getItem error: " + error);
          }
        }

        var manifest = this.innerStorage.get(key);

        if (manifest) {
          result.status = "ok";
          result.data = manifest;
        }

        return result;
      }
    }, {
      key: "set_manifest_by_doi",
      value: function set_manifest_by_doi(manifest, doi) {
        var key = MANIFEST_PREFIX + doi;

        if (this.Use_localStorage) {
          try {
            localStorage.setItem(key, manifest.ToString());
            return;
          } catch (error) {
            console.log("set_manifest_by_doi, localStorage.setItem error: " + error);
          }
        }

        this.innerStorage.set(key, manifest);
      }
    }, {
      key: "delete_manifest_by_doi",
      value: function delete_manifest_by_doi(doi) {
        var key = MANIFEST_PREFIX + doi;

        if (this.Use_localStorage) {
          try {
            if (localStorage.getItem(key)) {
              localStorage.removeItem(key);
              return true;
            }
          } catch (error) {
            console.log("delete_manifest_by_doi, localStorage error: " + error);
          }
        }

        return this.innerStorage.delete(key);
      }
    }, {
      key: "get_data_by_doi",
      value: function get_data_by_doi(doi) {
        var result = {
          status: "Not found",
          data: null
        };
        var key = RAWDATA_PREFIX + doi;
        var raw_data = null;

        if (this.Use_localStorage) {
          try {
            raw_data = localStorage.getItem(key);

            if (raw_data) {
              result.status = "ok";
              var length = Math.ceil(raw_data.length / 2);
              result.data = new Uint8Array(length);

              for (var i = 0; i < length; i++) {
                result.data[i] = parseInt(raw_data.substr(i * 2, 2), 16);
              }

              return result;
            }
          } catch (error) {
            console.log("get_data_by_doi, localStorage.getItem error: " + error);
          }
        }

        if (!raw_data) {
          raw_data = this.innerStorage.get(key);

          if (raw_data) {
            result.status = "ok";
            result.data = raw_data;
          }
        }

        return result;
      }
    }, {
      key: "get_data_by_manifest",
      value: function get_data_by_manifest(manifest) {
        var result = {
          status: "Not found",
          data: null
        };
        var dois = manifest.get_doi();

        if ("ok" === dois.status) {
          for (var doi in dois.data) {
            var data = this.get_data_by_doi(dois.data[doi]);

            if ("ok" === data.status) {
              result.status = "ok";
              result.data = data.data;
              return result;
            }
          }
        } else result.status = "Manifest has no doi";

        return result;
      }
    }, {
      key: "set_data_by_doi",
      value: function set_data_by_doi(data, doi) {
        var key = RAWDATA_PREFIX + doi;
        var array_data = new Uint8Array(data);

        if (this.Use_localStorage) {
          var value = "";

          for (var i = 0; i < array_data.length; i++) {
            value += array_data[i].toString(16).padStart(2, "0");
          }

          try {
            localStorage.setItem(key, value);
            return;
          } catch (error) {
            console.log("set_data_by_doi, localStorage.setItem error: " + error);
          }
        }

        this.innerStorage.set(key, array_data);
      }
    }, {
      key: "delete_data_by_doi",
      value: function delete_data_by_doi(doi) {
        var key = RAWDATA_PREFIX + doi;

        if (this.Use_localStorage) {
          try {
            if (localStorage.getItem(key)) {
              localStorage.removeItem(key);
              return true;
            }
          } catch (error) {
            console.log("delete_data_by_doi, localStorage error: " + error);
          }
        }

        return this.innerStorage.delete(key);
      }
    }, {
      key: "clear",
      value: function clear() {
        var cached_manifests = this.get_cached_manifests();

        for (var i = 0; i < cached_manifests.length; i++) {
          this.delete_manifest_by_doi(cached_manifests[i].doi);
        }

        var cached_data = this.get_cached_data();

        for (var i = 0; i < cached_data.length; i++) {
          this.delete_data_by_doi(cached_data[i].doi);
        }

        var size = cached_manifests.length + cached_data.length;
        return 0 !== size ? true : false;
      }
    }, {
      key: "get_cached_manifests",
      value: function get_cached_manifests() {
        var result = [];

        if (this.Use_localStorage) {
          try {
            for (var i = 0; i < localStorage.length; i++) {
              var _key = localStorage.key(i);

              if (true === _key.startsWith(MANIFEST_PREFIX)) {
                var doi = _key.replace(MANIFEST_PREFIX, "");

                var manifest = this.get_manifest_by_doi(doi).data;
                result.push({
                  doi: doi,
                  value: manifest
                });
              }
            }
          } catch (error) {
            console.log("get_cached_manifests, localStorage error: " + error);
          }
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.innerStorage.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (true === key.startsWith(MANIFEST_PREFIX)) {
              var _doi = key.replace(MANIFEST_PREFIX, "");

              var _manifest2 = this.get_manifest_by_doi(_doi).data;
              result.push({
                doi: _doi,
                value: _manifest2
              });
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return result;
      }
    }, {
      key: "get_cached_manifests_size",
      value: function get_cached_manifests_size() {
        var result = 0;

        if (this.Use_localStorage) {
          try {
            for (var i = 0; i < localStorage.length; i++) {
              var _key2 = localStorage.key(i);

              if (true === _key2.startsWith(MANIFEST_PREFIX)) result++;
            }
          } catch (error) {
            console.log("get_cached_manifests_size, localStorage error: " + error);
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.innerStorage.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var key = _step2.value;
            if (true === key.startsWith(MANIFEST_PREFIX)) result++;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return result;
      }
    }, {
      key: "get_cached_data",
      value: function get_cached_data() {
        var result = [];

        if (this.Use_localStorage) {
          try {
            for (var i = 0; i < localStorage.length; i++) {
              var _key3 = localStorage.key(i);

              if (true === _key3.startsWith(RAWDATA_PREFIX)) {
                var doi = _key3.replace(RAWDATA_PREFIX, "");

                var data = this.get_data_by_doi(doi).data;
                result.push({
                  doi: doi,
                  value: data
                });
              }
            }
          } catch (error) {
            console.log("get_cached_data, localStorage error: " + error);
          }
        }

        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.innerStorage.keys()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var key = _step3.value;

            if (true === key.startsWith(RAWDATA_PREFIX)) {
              var _doi2 = key.replace(RAWDATA_PREFIX, "");

              var _data = this.get_data_by_doi(_doi2).data;
              result.push({
                doi: _doi2,
                value: _data
              });
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return result;
      }
    }, {
      key: "get_cached_data_size",
      value: function get_cached_data_size() {
        var result = 0;

        if (this.Use_localStorage) {
          try {
            for (var i = 0; i < localStorage.length; i++) {
              var _key4 = localStorage.key(i);

              if (true === _key4.startsWith(RAWDATA_PREFIX)) result++;
            }
          } catch (error) {
            console.log("get_cached_data_size, localStorage error: " + error);
          }
        }

        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = this.innerStorage.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var key = _step4.value;
            if (true === key.startsWith(RAWDATA_PREFIX)) result++;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return result;
      }
    }]);

    return _class;
  }();
})();